import {InputLabel, styled} from '@mui/material'
import {Texts} from 'appearance'
import {Controller} from 'react-hook-form'
import Input from '../Input'

const FormInput = ({
    name,
    label,
    LabelComponent,
    control,
    formErrors,
    required,
    rules,
    type,
    disabled,
    orientation = 'horizontal',
    readOnly,
    InputProps,
    ...p
}) => {
    const orientationStyles = {
        horizontal: {alignItems: 'center'},
        vertical: {
            flexDirection: 'column',
        },
    }

    const requiredSign = required ? ' *' : ''

    return (
        <Container style={orientationStyles[orientation]}>
            {LabelComponent ? (
                <LabelComponent />
            ) : (
                <Label>{`${label}${requiredSign}`}</Label>
            )}
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) =>
                    !readOnly ? (
                        <Input
                            name={name}
                            onChange={onChange}
                            value={value === null ? undefined : value}
                            fullWidth={true}
                            required={required}
                            disabled={disabled}
                            type={type}
                            InputProps={InputProps}
                            error={formErrors?.[name]?.message}
                            {...p}
                        />
                    ) : (
                        <Value>{value}</Value>
                    )
                }
            />
        </Container>
    )
}

export default FormInput

const Container = styled('div')`
    display: flex;
`

const Label = styled(InputLabel)`
    font-size: 16px;
    font-weight: bold;
    flex: 2;
    right: 0px;
`
const Value = styled(Texts.RegularText)`
    flex: 4;
`
